import { Box, Skeleton, Stack, Typography } from '@customink/pigment-react';

import { useOrderDiscountTotal } from '@/hooks/Pricing';

export function OrderTotal() {
  const { orderTotal, isLoading } = useOrderDiscountTotal();

  return (
    <Stack data-testid="order-line-items">
      <Box display="flex" justifyContent="space-between">
        <Typography variant="heading4">Total</Typography>
        <Typography
          className={isLoading ? 'pje-fetching-text' : ''}
          data-testid="order-total-amount"
          variant="heading4"
        >
          $
          {isLoading ? (
            <Skeleton sx={{ display: 'inline-block' }} width={25} />
          ) : (
            orderTotal
          )}
        </Typography>
      </Box>
    </Stack>
  );
}
